import { toast } from "@/components/ui/";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { isAuthenticatedAtom } from "@/store/authAtoms";
import { appStore } from "@/store/jotaiStore";
import { type MutationKey, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { AUTH_MUTATION_KEYS, type TokenResponse } from "../types/auth";
import { setTokensInStorage } from "../utils/tokenStorage";

export const useGoogleLogin = (redirectTo: string) => {
  const queryClient = useQueryClient();
  const { navigate } = useRouter();

  return useApiMutation<TokenResponse, { token: string }>({
    mutationOptions: {
      mutationKey: AUTH_MUTATION_KEYS.GOOGLE as MutationKey,
      mutationFn: async ({ token }) => {
        const response = await axiosInstance.get("/auth/oauth/curai", {
          headers: {
            "Access-Token": token,
          },
        });
        return response.data;
      },
      onSuccess: async (response) => {
        await setTokensInStorage(response);
        // See useLogin: navigate from here (not the component) so the redirect
        // survives the root layout remount triggered by the auth flip.
        appStore.set(isAuthenticatedAtom, true);
        // href (not to) so a redirect carrying a query string navigates whole.
        navigate({ href: redirectTo, replace: true });
        toast.success("Google login successful");
        await queryClient.invalidateQueries();
      },
      onError: (error) => {
        console.warn(error);
      },
    },
  });
};
